import { authClient, authResponse, createAuthClient } from "./client";

type Options = {
  baseURL?: string;
  fetcher?: (input: string, init?: RequestInit) => Promise<Response>;
};
function clientFor(options: Options) {
  return options.baseURL
    ? createAuthClient(
        options.baseURL,
        options.fetcher
          ? (input, init) => options.fetcher!(String(input), init)
          : fetch,
      )
    : authClient;
}
export async function downloadAccountData(
  options: Options & {
    now?: () => Date;
    save?: (body: Blob, filename: string) => void;
  } = {},
): Promise<void> {
  const body = authResponse(await clientFor(options).exportAccount.mutate({}));
  const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
  const date = (options.now ?? (() => new Date()))().toISOString().slice(0, 10);
  const filename = `puzzleini-account-data-${date}.json`;
  if (options.save) {
    options.save(blob, filename);
    return;
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
export async function deleteAccount(options: Options = {}): Promise<void> {
  authResponse(
    await clientFor(options).deleteAccount.mutate({ confirmation: "DELETE" }),
  );
}
